export enum KamPushSegmentEvent {
  Normal = 'Normal',
  Explicit = 'Explicit',
  NewVacancy = 'New Vacancy',
  SixPlusMonthsReactivated = '6+ Monate Reaktiviert',
}
